import { methods } from "../../utils/axios";

export default class SkillsAPI {
  static createSkill(data) {
    return methods.post('/competences', data);
  }

  static listSkills(){
    return methods.get('/competences_list')
  }

  static paginateSkills(params){
    return methods.post('/competences/paginate', params)
  }

  static deleteSkills(id){
    return methods.del('/competences', id)
  }

  static updateSkills(data){
    return methods.put('/competences', data)
  }
}